module.exports = __webpack_public_path__ + "img/bm_selected.a7f0d5da.png";